import React, { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import { russianEndingsForm } from 'core/utils'
import {
    format,
    addDays,
} from 'date-fns'
import ru from 'date-fns/locale/ru'

import './LifeIndicator.scss'

const CLIENT_NAMES = [
    'Сергей',
    'Иван',
    'Виктор',
    'Антон',
    'Александр',
    'Борис',
    'Алексей',
    'Никита',
    'Евгений',
    'Григорий',
    'Николай',
    'Роман',
    'Руслан',
    'Дмитрий',
    'Платон',
    'Виталий',
    'Константин',
    'Даниил',
    'Давид',
    'Тимур',
]

const LIFE_TEXT_TEMPLATES = [
    '{{number_clients}} просматривают заказ машины на {{day_month}}',
    '{{client_name}} заказал перевозку холодильника на {{day_month}}',
    '{{client_name}} заказал перевозку дивана на {{day_month}}',
    '{{client_name}} заказал перевозку шкафа и комода на {{day_month}}',
    '{{client_name}} заказал перевозку шкафа на {{day_month}}',
    '{{client_name}} заказал перевозку телевизора на {{day_month}}',
    'На {{day_month}} осталось {{number_free_cars}}',
]

const MAX_INTERVAL_MS = 15000
const MIN_INTERVAL_MS = 6000

class LifeIndicator extends Component {
    
    state = {
        messages: [],
    }
    
    stopIndicator = false
    
    getRandMessage = () => {
        const replacer = (match) => {
            switch (match) {
                case '{{number_clients}}':
                    const numClients = Math.round(Math.random() * (20 - 3)) + 3
                    return `${numClients} ${russianEndingsForm(numClients, 'клиент', 'клиента', 'клиентов')}`
                case '{{day_month}}':
                    const day = addDays(new Date(), Math.round(Math.random() * (15 - 2)) + 2)
                    return format(day, 'D MMMM', {locale: ru})
                case '{{client_name}}':
                    return CLIENT_NAMES[Math.floor(Math.random() * CLIENT_NAMES.length)]
                case '{{number_free_cars}}':
                    const numCars = Math.round(Math.random() * (5 - 1)) + 1
                    return `${numCars} ${russianEndingsForm(numCars, 'свободная', 'свободные', 'свободных')} ${russianEndingsForm(numCars, 'машина', 'машины', 'машин')}`
                default:
                    return ''
            }
        }
        
        return LIFE_TEXT_TEMPLATES[Math.floor(Math.random() * LIFE_TEXT_TEMPLATES.length)].replace(/{{\w+}}/gm, replacer)
    }
    
    componentWillMount() {
        const messages = this.state.messages
        messages.push(this.getRandMessage())
    
        this.setState({
            messages,
        })
    }
    
    componentDidMount() {
        (function loop() {
            const rand = Math.round(Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS)) + MIN_INTERVAL_MS
            
            setTimeout(() => {
                const messages = this.state.messages
                messages.unshift(this.getRandMessage())
                
                if (!this.stopIndicator) {
                    this.setState({
                        messages,
                    }, () => {
                        messages.pop()
                        this.setState({
                            messages,
                        }, () => loop.call(this))
                    })
                }
            }, rand)
        }.call(this))
    }
    
    componentWillUnmount() {
        this.stopIndicator = true
    }
    
    render() {
        const messages = this.state.messages.map(item => (
            <div key={item}>{item}</div>
        ))
        
        return (
            <div className="LifeIndicator">
                <div>
                    <CSSTransitionGroup
                        transitionName="change"
                        transitionEnterTimeout={400}
                        transitionLeaveTimeout={400}>
                        {messages}
                    </CSSTransitionGroup>
                </div>
            </div>
        )
    }
}

export default LifeIndicator



// WEBPACK FOOTER //
// ./client/components/LifeIndicator/LifeIndicator.js